import { EventBasedFilter } from "../models/EventBasedFilter"
import { MultiSelectOption } from "../models/MultiSelectOption"

export enum PATTERN  {
    DAILY = "DAILY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY",
    YEARLY = "YEARLY"
}

export const SCHEDULE_NOTIFICATION_TYPE_ID = "1";
export const EVENT_BASED_NOTIFICATION_TYPE_ID = "2";

export enum RECURRENCE {
    END_BY = "END_BY",
    END_AFTER = "END_AFTER",
    NO_END_DATE = "NO_END_DATE"
}

export const DAILY_OPTION  = {
    EVERY : "every",
    EVERY_WEEKDAY : "everyWeekday"
}

export const MONTHLY_OPTION = {
    DAY: "day",
    THE: "the"
}

export const YEARLY_OPTION = {
    ON: "on",
    ON_THE: "onThe"
}

export const RECURRENCE_OPTION = {
    FIRST: "FIRST",
    SECOND: "SECOND",
    THIRD: "THIRD",
    FOURTH: "FOURTH",
    LAST: "LAST"
}

export const DAYS_OF_THE_WEEK = {
    MONDAY: "MON",
    TUESDAY: "TUE",
    WEDNESDAY: "WED",
    THURSDAY: "THU",
    FRIDAY: "FRI",
    SATURDAY: "SAT",
    SUNDAY: "SUN"
}

export const FILTER_TIME_ZONE: string = "FILTER_TIME_ZONE";
export const RANGE_START_DATE: string = "RANGE_START_DATE";
export const START_TIME: string = "START_TIME";
export const RANGE_END_DATE: string = "RANGE_END_DATE";
export const RANGE_OCCURRENCE: string = "RANGE_OCCURRENCE";
export const PATTERN_EVERY_WEEK: string = "PATTERN_EVERY_WEEK";
export const PATTERN_EVERY_DAY: string = "PATTERN_EVERY_DAY";
export const PATTERN_EVERY_MONTH: string = "PATTERN_EVERY_MONTH";
export const PATTERN_EVERY_YEAR: string = "PATTERN_EVERY_YEAR";
export const PATTERN_DAY_OF_WEEK: string = "PATTERN_DAY_OF_WEEK";
export const PATTERN_DAY_TYPE = "PATTERN_DAY_TYPE";
export const PATTERN_MONTH_OF_YEAR: string = "PATTERN_MONTH_OF_YEAR";
export const PATTERN_DAY_OF_MONTH: string = "PATTERN_DAY_OF_MONTH";
export const TO_RECIPIENT: string = "TO_RECIPIENT";
export const CC_RECIPIENT: string = "CC_RECIPIENT";
export const MSG_SUBJECT: string = "MSG_SUBJECT";
export const MSG_BODY: string = "MSG_BODY";
export const MSG_DISCLAIMER = "MSG_DISCLAIMER";

export const FILTER_EVENTS: string = "FILTER_EVENTS";
export const FILTER_SITES: EventBasedFilter = { sdValstring: "9", eSysnameLookup: "FILTER_SITES",relationType:"site" };
export const FILTER_BUILDINGS: EventBasedFilter = { sdValstring: "10", eSysnameLookup: "FILTER_BUILDINGS",relationType:"building" };
export const FILTER_ZONES: EventBasedFilter = { sdValstring: "11", eSysnameLookup: "FILTER_ZONES",relationType:"zone" };
export const FILTER_DEVICE_TYPE: EventBasedFilter = { sdValstring: "12", eSysnameLookup: "FILTER_DEVICE_TYPE",relationType:"deviceImprox" };
export const FILTER_DOORS: EventBasedFilter = { sdValstring: "3", eSysnameLookup: "FILTER_DOORS",relationType:"location" };

export const SCHEDULE_REPORT = "Scheduled Report";
export const EVENT_BASED_REPORT = "Event-based Notification";

export const SCHEDULE_NOTIFICATION = 1;
export const EVENT_BASED_NOTIFICATION = 2;

export const VRULE_TRIGGERS_IDS = {
    SCHEDULE: "1",
    EVENT : "2",
    LOCATION : "3",
    MANUAL : "4",
    SYSTEM_DRIVEN : "5",
    EXPIRATION : "6",
    AUDIT_CHANGE : "7",
    AFFECTED_PARTIES: "8",
    SITE : "9",
    BUILDING :"10",
    ZONE :"11",
    DEVICE_TYPE :"12",
}

export const MAX_RECORDS = 21;
